<template>
    <v-container class="pa-2">
        <!-- Header -->
        <v-card class="rounded-xl elevation-2 px-3 py-2 mb-3 sticky-header">
            <div class="d-flex align-center">
                <v-btn icon small text color="primary" @click="$emit('close')">
                    <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                <div class="ml-2 flex-grow-1 text-subtitle-2 font-weight-bold primary--text">
                    {{ titolo }}
                </div>
            </div>
            <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                placeholder="Cerca congregazione..."
                outlined rounded dense hide-details clearable
                autofocus
                class="mt-2"
            />
        </v-card>

        <!-- Lista -->
        <v-card
            v-for="item in filtrati"
            :key="item.id"
            class="rounded-xl elevation-1 mb-2 cong-card"
            @click="$emit('selected', item)"
        >
            <div class="d-flex align-center px-4 py-3">
                <v-icon color="teal" class="mr-3">mdi-home-city-outline</v-icon>
                <div class="flex-grow-1">
                    <div class="text-body-2 font-weight-bold">{{ item.nome }}</div>
                    <div v-if="item.giorno || item.ora" class="text-caption grey--text">
                        {{ item.giorno }} {{ item.ora }}
                    </div>
                    <div v-if="item.prenotazione" class="text-caption orange--text darken-1 d-flex align-center mt-1">
                        <v-icon x-small color="orange darken-1" class="mr-1">mdi-alert-outline</v-icon>
                        {{ item.prenotazione }}
                    </div>
                </div>
                <v-icon color="grey lighten-1" size="18">mdi-chevron-right</v-icon>
            </div>
        </v-card>

        <div v-if="filtrati.length === 0" class="text-center grey--text py-10">
            <v-icon large color="grey lighten-1">mdi-home-city-outline</v-icon>
            <div class="mt-2 text-body-2">Nessuna congregazione trovata</div>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'SelectCongregazione',
    props: {
        items:  { type: Array, default: () => [] },
        titolo: { type: String, default: 'Seleziona congregazione' },
    },
    data: () => ({ search: '' }),
    computed: {
        filtrati() {
            if (!this.search) return this.items;
            const s = this.search.toLowerCase();
            return this.items.filter(c => (c.nome || '').toLowerCase().includes(s));
        },
    },
};
</script>

<style scoped>
.sticky-header { position: sticky; top: 0; z-index: 4; }
.cong-card { cursor: pointer; transition: box-shadow 0.15s; }
.cong-card:hover { box-shadow: 0 4px 16px rgba(0,0,0,0.13) !important; }
</style>
